export default "__VITE_ASSET__08a05b5c__"